<template>
  <Popover ref="listInfoPopover" :showHeader="true" :headerTitle="headerTitle">
    <div class="order-item-popover-content order-item-error-popover-content">
      <ul v-html="convertNewlinesToListItems(description || '')" class="popover-list"></ul>
    </div>
  </Popover>
</template>


<script>
import Popover from '@/components/popover.vue'

export default {
  components: {
    Popover
  },
  props: {
    headerTitle: String,
    description: {
      type: String,
      default: ''
    }
  },
  methods: {
    displayFromElement(element) {
      this.$refs.listInfoPopover.displayFromElement(element)
    }
  }
}
</script>